import { deleteLocalThunk, updateLocalThunk } from '@spike/block-calendar-action';
import { MasterData } from '@spike/masterdata-model';
import { BlockCalendarWebSocketsMessage } from 'model/WebSockets';
import { Dispatch } from 'redux';
import { debugConsoleLog } from 'utils/GeneralUtils';
import { websocketLog } from '../websocketLog';

export const handleBlockCalendarsWebSocketMessage = (
    message: BlockCalendarWebSocketsMessage,
    dispatch: Dispatch,
    timeZone: string,
    masterData: MasterData
): void => {
    websocketLog('message', 'BlockCalendarsWebSockets', {
        blockCalendarId: message.block_calendar?.id,
        deleted: message.deleted
    });

    if (message.block_calendar && !message.destroyed) {
        debugConsoleLog(`---> Update Block Calendar, id = ${message.block_calendar.id}`);
        dispatch(updateLocalThunk(message.block_calendar, timeZone, masterData));
    }

    if (message.block_calendar && message.destroyed) {
        debugConsoleLog(`---> Remove Block Calendar, id = ${message.block_calendar.id}`);
        dispatch(deleteLocalThunk([message.block_calendar?.id ?? 0]));
    }

    if ((message.deleted ?? []).length > 0) {
        debugConsoleLog(`---> Remove Block Calendar, ids = ${message.deleted}`);
        dispatch(deleteLocalThunk(message.deleted ?? []));
    }
};
